import { createStore } from "redux";
import {
  SET_ACTIVE_STATE,
  SET_TITLE,
  TOGGLE_DRAWER,
  TOGGLE_SIDE_NAV,
} from "./helper/constants";
import { appendEmailSyncEvent } from "./utils/emailSyncQueue";

const initialState = {
  isOpenByOwner: false,
  drawerOpen: false,
  sideNavOpen: true,
  getCounters: false,
  unseenNewsCount: 0,
  unseenChatCount: 0,
  unseenBuildingChatCount: 0,
  unseenExternalProject: 0,
  unseenInternalProject: 0,
  user: null,
  userData: [],
  title: "User Dashboard",
  setting: null,
  loader: false,
  deeplinkLoading: false,
  deeplinkLoadingInternal: false,
  deeplinkLoadingMessage: null, // 'navigating_to_room' | null (null = default chat loading)
  projects: [],
  internalProjectsAll: [],
  openProjects: [],
  pinnedRooms: [],
  activePinnedRoomId: null,
  // Company-admin oversight: { id, companyId } of the room shown in the room column.
  oversightRoom: null,
  updateProjectActionFire: false,
  // When a room is opened from an email's project tag, remember which email to
  // surface inside that room's E-Mail section: { buildingId, emailId } | null.
  pendingEmailOpen: null,
  // Chat the Nachrichten screen should open on arrival, with the message to
  // scroll to: { chatGroupId, messageId, page_no, roomId, … } | null.
  pendingChat: null,
  // Task a project should show once it is open (Aufgaben pane):
  // { roomId, todoId } | null. Consumed once by that project's ToDo pane.
  pendingProjectTask: null,
  article: null,
  articlesList: [],
  currentArticleIndex: 0,
  toggleWorkArea: true,
  rightTop: "",
  rightBottom: "chat2",
  groups: [],
  groupsBottom: [],
  openChats: [],
  openBottomChats: [],
  openBottomProjects: [],
  updateBottomProjectActionFire: false,
  projectRequestCount: 0,
  forwardMessage: false,
  messageIds: [],
  updateGroupMessage: {},
  language: null,
  groupChats: [],
  forwardGroupMessages: {},
  draftMessages: (() => {
    try {
      const v = localStorage.getItem("draftMessage");
      const parsed = v ? JSON.parse(v) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  })(),
  unSeenAllCount: {},
  // Article-feed watermarks (unix seconds) from /badge/count. The feed freezes
  // these on entry so a card can keep its "NEW" ribbon after the counter is
  // cleared: { external: number, byCompany: { [companyId]: number } }.
  articleSeenAt: { external: 0, byCompany: {} },
  unseenTodoCount: 0,
  unseenDailyBriefingCount: 0,
  // Per-room unread reports from /badge/count. null = not loaded yet so
  // /building/my values are kept; {} or a map replaces room counts.
  unseenDailyBriefingByBuilding: null,
  unseenEmojiReactionCount: 0,
  AllGroupsOfProjects: [],
  joinRequestsInternal: [],
  joinRequestsExternal: [],
  isExternalSelected: 0,
  companyImage: null,
  selectedCompanyName: null,
  selectedCompanyId: null,
  resetSocket: false,
  forOpenChatId: null,
  ViewerImages: [],
  inActivity: false,
  activityMessages: [],
  activityMessagesReminders: [],
  mySpacePin: null,
  // Message ids that received a quick-reaction while the user wasn't in the
  // chat. Consumed (and highlighted) when the user next opens that chat.
  newReactionMessageIds: [],
  isNewMessage: false,
  resetProjectMarking: false,
  initalIndex: 0,
  isAutoTranslation: true,
  translateRoomAndGroupNames: (() => { try { return localStorage.getItem('translateRoomAndGroupNames') === 'true'; } catch(e) { return false; } })(),
  autoTranslationLanguages: (() => { try { const v = localStorage.getItem('autoTranslationLanguages'); return v ? JSON.parse(v) : null; } catch(e) { return null; } })(),
  userLoginToken: null,
  isUnauthorized: false,
  isJitsiCallStarted: false,
  joinNowRoomWise: [],
  shouldUpdateProjectDetails: false,
  showListOngoing: false,
  runningCalls: [],
  activeSideBar:'articles',
  refreshGroupMessages:false,
  fromForeignprofile:false,
  isDeskTopResolution: true,
  openChatToggle: true,
  openProjectToggle: true,
  openProjectDetailToggle: true,
  openGroupChatToggle: true,
  openLatestMsgToggle: true,
  deeplinkData: null,
  isSearchOpen: false,
  resetLatestMessages: false,
  fetchAllRequeest:false,
  showTodoView: false,
  todoListRefreshTrigger: 0,
  todoCalendarDeletedTodoId: null,
  // The event of a ToDo the user added to their calendars was deleted there (todoCalendarSync
  // "removed_from_calendar"): its calendar button turns off.
  todoCalendarRemovedSeq: 0,
  todoCalendarRemovedTodoId: null,
  todoRemovedSeq: 0,
  todoRemovedTodoId: null,
  todoRemovedGroupId: null,
  todoRemovedEmailId: null,
  bookmarkedChatIds: [],
  pendingBookmarks: [],
  bookmarkTodoEventSeq: 0,
  bookmarkTodoEvent: null,
  newMessagedata:null,
  newGroupData:null,
  chatFullscreen: false, // When true, hide chat list panel and show only conversation
  // Message caching
  cachedMessages: {},  // { [chatId]: { data: [], lastFetched: timestamp, lastMessageId: string } }
  activityMessagesLastFetched: null,  // Timestamp for chat list cache freshness
  emailSyncData: null,
  // Every socket "email" event in order (see utils/emailSyncQueue).
  emailSyncEvents: [],
  emailSyncSeq: 0,
  // Bumped after a socket reconnect, tab return or network return: anything
  // pushed while the socket was down was missed, so open lists re-fetch.
  emailCatchUpAt: null,
  // Bumped whenever another device links/unlinks an email account, so screens
  // that keep a local copy of the account list can re-fetch in real time.
  emailAccountsChangedAt: null,
  unseenEmailCount: 0,
  emailSearchQuery: '',
  emailSearchResults: [],
  emailSearchPagination: { page: 1, hasMore: false },
  isEmailSearching: false,
  emailSearchError: null,
  emailAccounts: [],
  emailCustomFolders: [],
  // Kjuup.io Stripe entitlement (webhook-backed; never set optimistically)
  subscription: {
    active: false,
    plan: null,
    subscriptionStatus: null,
    currentPeriodEnd: null,
    cancelAtPeriodEnd: false,
    subscriptionId: null,
    pendingPlan: null,
    pendingStartDate: null,
    hasScheduledSwitch: false,
    trialing: false,
    trialEnd: null,
    daysRemaining: null,
    trialDaysRemaining: null,
    hasPaymentMethod: false,
    hasUsedTrial: false,
    canStartTrial: true,
    isKjuupPlusMember: false,
    stripeFeatureEnabled: false,
    companyStripeFeatureEnabled: false,
    source: null,
    companyBilling: null,
    companyTrialEnded: false,
    showCompanyTrialEndedNote: false,
    isCompanyAdmin: false,
    hasCompanySeat: false,
    companyAdmins: [],
    loading: false,
    lastFetchedAt: null,
  },
};
export const SET_NEW_MESSAGE_DATA = Symbol("SET_NEW_MESSAGE_DATA");
export const IS_OPEN_BY_OWNER = Symbol("IS_OPEN_BY_OWNER");
export const SET_IS_UNAUTHORIZED = Symbol("SET_IS_UNAUTHORIZED");
export const SET_USER = Symbol("SET_USER");
export const SET_USER_LOGIN_TOKEN = Symbol("SET_USER_LOGIN_TOKEN");
export const SET_PROFILE = Symbol("SET_PROFILE");
export const SET_SETTING = Symbol("SET_SETTING");
export const SET_LOADER = Symbol("SET_LOADING");
export const PROJECTS = Symbol("PROJECTS");
export const SET_IN_ACTIVITY = Symbol("SET_IN_ACTIVITY");
export const SET_ALLGROUPS_PROJECTS = Symbol("PROJECTS");
export const INTERNAL_PROJECTS = Symbol("INTERNAL_PROJECTS");
export const OPEN_PROJECTS = Symbol("OPEN_PROJECTS");
export const SET_PINNED_ROOMS = Symbol("SET_PINNED_ROOMS");
export const SET_ACTIVE_PINNED_ROOM_ID = Symbol("SET_ACTIVE_PINNED_ROOM_ID");
export const SET_OVERSIGHT_ROOM = Symbol("SET_OVERSIGHT_ROOM");
export const UPDATE_PROJECT_ACTION_FIRE = Symbol("UPDATE_PROJECT_ACTION_FIRE");
export const OPEN_BOTTOM_PROJECTS = Symbol("OPEN_BOTTOM_PROJECTS");
export const UPDATE_BOTTOM_PROJECT_ACTION_FIRE = Symbol(
  "UPDATE_BOTTOM_PROJECT_ACTION_FIRE"
);
export const ARTICLE = Symbol("ARTICLE");
export const RESET = Symbol("RESET");
export const TOGGLE_WORK_AREA = Symbol("TOGGLE_WORK_AREA");
export const RIGHT_TOP = Symbol("RIGHT_TOP");
export const RIGHT_BOTTOM = Symbol("RIGHT_BOTTOM");
export const GROUPS = Symbol("GROUPS");
export const OPEN_CHATS = Symbol("OPEN_CHATS");
export const OPEN_BOTTOM_CHATS = Symbol("OPEN_BOTTOM_CHATS");
export const GROUPS_BOTTOM = Symbol("GROUPS_BOTTOM");
export const NEWS_BADGE_COUNT = Symbol("NEWS_BADGE_COUNT");
export const ALL_BADGE_COUNT = Symbol("ALL_BADGE_COUNT");
// Unseen-article counters: BUMP applies the realtime +1 from the `articleBadge`
// socket event, FEED_SEEN clears one feed optimistically when it is opened.
export const ARTICLE_BADGE_BUMP = Symbol("ARTICLE_BADGE_BUMP");
export const ARTICLE_FEED_SEEN = Symbol("ARTICLE_FEED_SEEN");
export const CHAT_BADGE_COUNT = Symbol("CHAT_BADGE_COUNT");
export const PROJECT_BADGE_COUNT = Symbol("PROJECT_BADGE_COUNT");
export const UNSEEN_EXTERNAL_BADGE = Symbol("UNSEEN_EXTERNAL_BADGE");
export const UNSEEN_INTERNAL_BADGE = Symbol("UNSEEN_INTERNAL_BADGE");
export const GET_COUNTERS = Symbol("GET_COUNTERS");
export const SET_JOIN_REQUEST_INTERNAL = Symbol("SET_JOIN_REQUEST_INTERNAL");
export const SET_JOIN_REQUEST_EXTERNAL = Symbol("SET_JOIN_REQUEST_EXTERNAL");
export const START_JITSI_CALL = Symbol("START_JITSI_CALL");
export const JOIN_ROOM_BUTTON_STATUS_ROOM_WISE = Symbol("JOIN_ROOM_BUTTON_STATUS_ROOM_WISE");
export const SET_OPEN_SIDE_BAR = Symbol("SET_OPEN_SIDE_BAR");
export const SET_SCREEN_TYPE = Symbol("SET_SCREEN_TYPE");
export const PROJECT_REQUEST_COUNT = Symbol("PROJECT_REQUEST_COUNT");
export const FORWARD_MESSAGE = Symbol("FORWARD_MESSAGE");
export const MESSAGE_IDS = Symbol("MESSAGE_IDS");
export const FOR_OPEN_CHAT_ID = Symbol("FOR_OPEN_CHAT_ID");
export const UPDATE_GROUP_MESSAGE = Symbol("UPDATE_GROUP_MESSAGE");
export const LANGUAGE = Symbol("LANGUAGE");
export const GROUP_CHATS = Symbol("GROUP_CHATS");
export const FORWARD_GROUP_MESSAGES = Symbol("FORWARD_GROUP_MESSAGES");
export const DRAFT_MESSAGES = Symbol("DRAFT_MESSAGES");
export const SET_TAB = Symbol("SET_TAB");
export const SET_COMPANY_IMAGE = Symbol("SET_COMPANY_IMAGE");
export const SET_COMPANY_ID = Symbol("SET_COMPANY_ID");
export const RESET_SOCKET = Symbol("RESET_SOCKET");
export const SET_VIEWER_IMAGES = Symbol("SET_VIEWER_IMAGES");
export const SET_VIEWER_IINITAL_INDEX = Symbol("SET_VIEWER_IINITAL_INDEX");
export const SET_VIEWER_IS_INTERNAL = Symbol("SET_VIEWER_IS_INTERNAL");
export const SET_ACTIVITY_MESSAGES = Symbol("SET_ACTIVITY_MESSAGES");
export const SET_ACTIVITY_MESSAGES_REMINDERS = Symbol("SET_ACTIVITY_MESSAGES_REMINDERS");
export const BUMP_CHAT_REACTION = Symbol("BUMP_CHAT_REACTION");
export const CLEAR_REACTION_MESSAGES = Symbol("CLEAR_REACTION_MESSAGES");
export const IS_NEW_MESSAGE = Symbol("IS_NEW_MESSAGE");
export const RESET_MARKIN_PROJECT = Symbol("RESET_MARKIN_PROJECT");
export const SET_AUTO_TRANSLATION = Symbol("SET_AUTO_TRANSLATION");
export const SET_TRANSLATE_ROOM_AND_GROUP_NAMES = Symbol("SET_TRANSLATE_ROOM_AND_GROUP_NAMES");
export const SET_AUTO_TRANSLATION_LANGUAGES = Symbol("SET_AUTO_TRANSLATION_LANGUAGES");
export const SET_DOCUMENT_CONTENT_SEARCH = Symbol("SET_DOCUMENT_CONTENT_SEARCH");
export const UPDATE_PROJECT_DETAILS = Symbol("UPDATE_PROJECT_DETAILS");
export const SHOW_LIST_ONGOING = Symbol("SHOW_LIST_ONGOING");
export const SET_RUNNING_CALLS = Symbol("SET_RUNNING_CALLS");
export const REFRESH_GROUP_MESSAGES = Symbol("REFRESH_GROUP_MESSAGES");
export const FROM_FROROIEGN_PROFILE = Symbol("FROM_FROROIEGN_PROFLE");
export const TOGGLE_CHAT = Symbol("TOGGLE_CHAT");
export const TOGGLE_PROJECT = Symbol("TOGGLE_PROJECT");
export const TOGGLE_PROJECT_DETAIL = Symbol("TOGGLE_PROJECT_DETAIL");
export const TOGGLE_GROUP_CHAT = Symbol("TOGGLE_GROUP_CHAT");
export const TOGGLE_LATEST_MSG = Symbol("TOGGLE_LATEST_MSG");
export const SET_DEEPLINK_DATA = Symbol("SET_DEEPLINK_DATA");
export const SET_DEEPLINK_LOADING = Symbol("SET_DEEPLINK_LOADING");
export const SET_PENDING_EMAIL_OPEN = Symbol("SET_PENDING_EMAIL_OPEN");
export const SET_SEARCH_STATUS = Symbol("SET_SEARCH_STATUS");
export const RESET_LATEST_MESSAGES = Symbol("RESET_LATEST_MESSAGES");
export const FETCH_ALL_REQUEST = Symbol("FETCH_ALL_REQUEST");
export const SET_NEW_GROUP_DATA = Symbol("SET_NEW_GROUP_DATA");
export const TOGGLE_TODO_VIEW = Symbol("TOGGLE_TODO_VIEW");
export const DECREMENT_UNSEEN_TODO_COUNT = Symbol("DECREMENT_UNSEEN_TODO_COUNT");
export const INCREMENT_UNSEEN_TODO_COUNT = Symbol("INCREMENT_UNSEEN_TODO_COUNT");
export const REFRESH_TODO_LIST = Symbol("REFRESH_TODO_LIST");
export const TODO_CALENDAR_DELETED = Symbol("TODO_CALENDAR_DELETED");
export const TODO_CALENDAR_REMOVED = Symbol("TODO_CALENDAR_REMOVED");
export const TODO_ITEM_REMOVED = Symbol("TODO_ITEM_REMOVED");
export const BOOKMARK_TODO_PENDING = Symbol("BOOKMARK_TODO_PENDING");
export const BOOKMARK_TODO_CREATED = Symbol("BOOKMARK_TODO_CREATED");
export const BOOKMARK_TODO_FAILED = Symbol("BOOKMARK_TODO_FAILED");
export const MERGE_BOOKMARKED_CHAT_IDS = Symbol("MERGE_BOOKMARKED_CHAT_IDS");
export const RESET_UNSEEN_TODO_COUNT = Symbol("RESET_UNSEEN_TODO_COUNT");
export const INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT = Symbol("INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT");
export const DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT = Symbol("DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT");
export const INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT = Symbol("INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT");
export const DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT = Symbol("DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT");
// Message caching actions
export const SET_CACHED_MESSAGES = Symbol("SET_CACHED_MESSAGES");
export const UPDATE_CACHED_MESSAGE = Symbol("UPDATE_CACHED_MESSAGE");
export const CLEAR_CACHED_MESSAGES = Symbol("CLEAR_CACHED_MESSAGES");
export const SET_ACTIVITY_MESSAGES_LAST_FETCHED = Symbol("SET_ACTIVITY_MESSAGES_LAST_FETCHED");
export const SET_CHAT_FULLSCREEN = Symbol("SET_CHAT_FULLSCREEN");
export const EMAIL_SYNC = Symbol("EMAIL_SYNC");
export const EMAIL_ACCOUNTS_CHANGED = Symbol("EMAIL_ACCOUNTS_CHANGED");
export const EMAIL_CATCH_UP = Symbol("EMAIL_CATCH_UP");
export const MY_SPACE_PINNED = Symbol("MY_SPACE_PINNED");
export const RESET_UNSEEN_EMAIL_COUNT = Symbol("RESET_UNSEEN_EMAIL_COUNT");
export const DECREMENT_UNSEEN_EMAIL_COUNT = Symbol("DECREMENT_UNSEEN_EMAIL_COUNT");
export const INCREMENT_UNSEEN_EMAIL_COUNT = Symbol("INCREMENT_UNSEEN_EMAIL_COUNT");
export const SET_PENDING_EMAIL = Symbol("SET_PENDING_EMAIL");
export const SET_PENDING_CHAT = Symbol("SET_PENDING_CHAT");
export const SET_PENDING_PROJECT_TASK = Symbol("SET_PENDING_PROJECT_TASK");
export const SET_EMAIL_SEARCH = Symbol("SET_EMAIL_SEARCH");
export const CLEAR_EMAIL_SEARCH = Symbol("CLEAR_EMAIL_SEARCH");
export const SET_EMAIL_ACCOUNTS = Symbol("SET_EMAIL_ACCOUNTS");
export const SET_EMAIL_CUSTOM_FOLDERS = Symbol("SET_EMAIL_CUSTOM_FOLDERS");
export const SET_SUBSCRIPTION_STATUS = Symbol("SET_SUBSCRIPTION_STATUS");
export const SET_SUBSCRIPTION_LOADING = Symbol("SET_SUBSCRIPTION_LOADING");
export const CLEAR_SUBSCRIPTION = Symbol("CLEAR_SUBSCRIPTION");

const SUBSCRIPTION_INITIAL = {
  active: false,
  plan: null,
  subscriptionStatus: null,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: false,
  subscriptionId: null,
  pendingPlan: null,
  pendingStartDate: null,
  hasScheduledSwitch: false,
  trialing: false,
  trialEnd: null,
  daysRemaining: null,
  trialDaysRemaining: null,
  // Admin Center trial length, and server clock minus browser clock at fetch.
  trialPeriodDays: null,
  clockOffsetMs: 0,
  // Company + personal discount on the personal plan ({ percent, … } or null).
  discount: null,
  hasPaymentMethod: false,
  hasUsedTrial: false,
  canStartTrial: true,
  isKjuupPlusMember: false,
  source: null,
  companyBilling: null,
  companyTrialEnded: false,
  showCompanyTrialEndedNote: false,
  isCompanyAdmin: false,
  hasCompanySeat: false,
  companyAdmins: [],
  loading: false,
  lastFetchedAt: null,
};
// Enable Redux DevTools if available
const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

function projectMatchesBuilding(project, buildingId) {
  if (!project || buildingId == null) return false;
  const id = String(buildingId);
  return String(project.id) === id || String(project.buildingList) === id;
}

function adjustProjectBriefingCount(projects, buildingId, delta) {
  if (!buildingId || !Array.isArray(projects) || !projects.length) return projects;
  let changed = false;
  const next = projects.map((p) => {
    if (!projectMatchesBuilding(p, buildingId)) return p;
    changed = true;
    return {
      ...p,
      unseenDailyBriefingCount: Math.max(0, (Number(p.unseenDailyBriefingCount) || 0) + delta),
    };
  });
  return changed ? next : projects;
}

// Keeps the Extern / Intern halves of the briefing badge in step with the total
// when a briefing is opened or restored, so the room tabs move immediately
// instead of waiting for the next /badge/count.
function adjustBriefingTabCounts(unSeenAllCount, isInternal, delta) {
  const prev = unSeenAllCount || {};
  const key = isInternal
    ? "unseenInternalDailyBriefingCount"
    : "unseenExternalDailyBriefingCount";
  return { ...prev, [key]: Math.max(0, (Number(prev[key]) || 0) + delta) };
}

function adjustInternalBriefingCount(companies, buildingId, delta) {
  if (!buildingId || !Array.isArray(companies) || !companies.length) return companies;
  let changed = false;
  const next = companies.map((company) => {
    const list = company && company.userProjectList;
    if (!Array.isArray(list) || !list.length) return company;
    let listChanged = false;
    const userProjectList = list.map((p) => {
      if (!projectMatchesBuilding(p, buildingId)) return p;
      listChanged = true;
      changed = true;
      return {
        ...p,
        unseenDailyBriefingCount: Math.max(0, (Number(p.unseenDailyBriefingCount) || 0) + delta),
      };
    });
    return listChanged ? { ...company, userProjectList } : company;
  });
  return changed ? next : companies;
}

function briefingCountForRoom(room, byBuilding) {
  if (!room) return 0;
  if (!byBuilding) return Number(room.unseenDailyBriefingCount) || 0;
  const id = room.id != null ? String(room.id) : "";
  const buildingList = room.buildingList != null ? String(room.buildingList) : "";
  if (id && byBuilding[id] != null) return Number(byBuilding[id]) || 0;
  if (buildingList && byBuilding[buildingList] != null) return Number(byBuilding[buildingList]) || 0;
  return 0;
}

function applyBriefingCountsToProjects(projects, byBuilding) {
  if (byBuilding == null || !Array.isArray(projects) || !projects.length) return projects;
  return projects.map((p) => ({
    ...p,
    unseenDailyBriefingCount: briefingCountForRoom(p, byBuilding),
  }));
}

function applyBriefingCountsToInternal(companies, byBuilding) {
  if (byBuilding == null || !Array.isArray(companies) || !companies.length) return companies;
  return companies.map((company) => {
    const list = company && company.userProjectList;
    if (!Array.isArray(list) || !list.length) return company;
    return {
      ...company,
      userProjectList: list.map((p) => ({
        ...p,
        unseenDailyBriefingCount: briefingCountForRoom(p, byBuilding),
      })),
    };
  });
}

function bumpBriefingByBuilding(byBuilding, buildingId, delta) {
  if (buildingId == null || byBuilding == null) return byBuilding;
  const key = String(buildingId);
  return {
    ...byBuilding,
    [key]: Math.max(0, (Number(byBuilding[key]) || 0) + delta),
  };
}

function bookmarkRecordKey(item) {
  if (!item) return "";
  return String(item.todoId || item.id || item.tempId || "");
}

function isTempBookmarkId(id) {
  const s = String(id || "");
  return !s || s.startsWith("pending-bookmark") || s.startsWith("creating-") || s.startsWith("local-");
}

function samePendingBookmark(a, b) {
  if (!a || !b) return false;
  const ak = bookmarkRecordKey(a);
  const bk = bookmarkRecordKey(b);
  if (ak && bk && ak === bk) return true;
  if (a.tempId && (b.tempId === a.tempId || b.id === a.tempId || b.todoId === a.tempId)) return true;
  if (b.tempId && (a.id === b.tempId || a.todoId === b.tempId)) return true;
  // Two persisted ToDos with different ids are distinct, even if they share a group.
  if (ak && bk && !isTempBookmarkId(ak) && !isTempBookmarkId(bk) && ak !== bk) return false;
  const aChat = String(a.chatId || a.messageId || a.chat || "");
  const bChat = String(b.chatId || b.messageId || b.chat || "");
  if (aChat && bChat && aChat === bChat) return true;
  const aGroup = String(a.groupId || a.group || "");
  const bGroup = String(b.groupId || b.group || "");
  if (aGroup && bGroup && aGroup === bGroup && !aChat && !bChat) return true;
  const aEmail = String(a.emailId || a.emailMessageId || "");
  const bEmail = String(b.emailId || b.emailMessageId || "");
  return !!(aEmail && bEmail && aEmail === bEmail);
}

function upsertPendingBookmark(list, item) {
  const prev = Array.isArray(list) ? list : [];
  if (!item) return prev;
  const idx = prev.findIndex((row) => samePendingBookmark(row, item));
  if (idx >= 0) {
    const next = [...prev];
    next[idx] = { ...prev[idx], ...item };
    return next;
  }
  return [item, ...prev];
}

function dropPendingBookmark(list, match) {
  if (!match) return Array.isArray(list) ? list : [];
  return (list || []).filter((row) => !samePendingBookmark(row, match));
}

// After a local mark-as-read the UI decrements immediately, then a still-in-flight
// or slightly-stale GET /badge/count can write the old leftover 1 back — the
// user-visible bug is "the last counter stays until I reload". While this guard
// is active, ALL_BADGE_COUNT may lower a bucket but must not raise one.
const BADGE_DECREASE_GUARD_MS = 5000;
const BADGE_GUARD_KEYS = [
  "unseenChatCount",
  "unseenInternalProject",
  "unseenExternalProject",
  "unseenEmailCount",
  "unseenAllScopeDailyBriefingCount",
  "unseenDailyBriefingCount",
  "unseenEmojiReactionCount",
];
let badgeDecreaseGuardUntil = 0;

function suppressBadgeIncreases() {
  badgeDecreaseGuardUntil = Date.now() + BADGE_DECREASE_GUARD_MS;
}

export function allowBadgeIncreases() {
  badgeDecreaseGuardUntil = 0;
}

function clampStaleBadgeIncreases(incoming, current) {
  if (!incoming || Date.now() > badgeDecreaseGuardUntil) return incoming;
  const next = { ...incoming };
  for (const key of BADGE_GUARD_KEYS) {
    const inc = Number(incoming[key]) || 0;
    const cur = Number(current?.[key]) || 0;
    if (inc > cur) next[key] = cur;
  }
  return next;
}

export const store = createStore(
  (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case SET_NEW_GROUP_DATA:
      return { ...state, newGroupData: action.payload };
    case SET_NEW_MESSAGE_DATA:
      return {
        ...state,
        newMessagedata: action.payload,
        ...(action.payload ? { activityMessagesLastFetched: null } : {}),
      };
    case FETCH_ALL_REQUEST:
      return { ...state, fetchAllRequeest: action.status };
    case RESET_LATEST_MESSAGES:
      return { ...state, resetLatestMessages: action.status };
    case TOGGLE_TODO_VIEW:
      return { ...state, showTodoView: action.payload };
    case SET_SEARCH_STATUS:
      return { ...state, isSearchOpen: action.payload };
    case SET_PENDING_EMAIL:
      return { ...state, pendingEmail: action.payload };
    case SET_PENDING_CHAT:
      return { ...state, pendingChat: action.payload };
    case SET_PENDING_PROJECT_TASK:
      return { ...state, pendingProjectTask: action.payload };
    case SET_DEEPLINK_LOADING:
      // Store both loading state and isInternal flag to preserve color during loading
      // When loading starts: set isInternal ONLY if explicitly provided, otherwise preserve current value
      // When loading ends: keep isInternal value so color stays consistent until hidden
      if (action.loading) {
        return { 
          ...state, 
          deeplinkLoading: true,
          deeplinkLoadingMessage: action.loadingMessage || null,
          // Only update if isInternal is explicitly provided (true or false)
          // If not provided (undefined), keep the current value to prevent color flashing
          deeplinkLoadingInternal: action.isInternal !== undefined 
            ? action.isInternal === true 
            : state.deeplinkLoadingInternal
        };
      } else {
        return { 
          ...state, 
          deeplinkLoading: false,
          deeplinkLoadingMessage: null
          // Keep deeplinkLoadingInternal unchanged - it will be set fresh on next loading: true
        };
      }
    case FROM_FROROIEGN_PROFILE:
      return { ...state, fromForeignprofile: action.payload };
    case REFRESH_GROUP_MESSAGES:
      return { ...state, refreshGroupMessages: action.status };
    case SET_IS_UNAUTHORIZED:
      return { ...state, isUnauthorized: action.status };
    case SET_RUNNING_CALLS:
      return { ...state, runningCalls: Array.isArray(action.payload) ? action.payload : [] };
    case SET_USER_LOGIN_TOKEN:
      return { ...state, userLoginToken: action.status };
    case RESET_MARKIN_PROJECT:
      return { ...state, resetProjectMarking: action.status };
    case SET_AUTO_TRANSLATION:
      return { ...state, isAutoTranslation: action.status };
    case SET_TRANSLATE_ROOM_AND_GROUP_NAMES: {
      const enabled = !!action.status;
      try {
        if (enabled) localStorage.setItem('translateRoomAndGroupNames', 'true');
        else localStorage.removeItem('translateRoomAndGroupNames');
      } catch (e) {}
      return { ...state, translateRoomAndGroupNames: enabled };
    }
    case SET_AUTO_TRANSLATION_LANGUAGES: {
      const langs = action.languages == null ? null : action.languages;
      try { if (langs) localStorage.setItem('autoTranslationLanguages', JSON.stringify(langs)); else localStorage.removeItem('autoTranslationLanguages'); } catch(e) {}
      return { ...state, autoTranslationLanguages: langs };
    }
    case SET_DOCUMENT_CONTENT_SEARCH:
      return { ...state, isDocumentContentSearch: action.status };
    case SET_ACTIVITY_MESSAGES_REMINDERS:
      return { ...state, activityMessagesReminders: action.messages };
    case IS_OPEN_BY_OWNER:
      return { ...state, isOpenByOwner: action.open };
    case SET_ACTIVITY_MESSAGES: {
      // Seed `newReactionMessageIds` from the BE-supplied `lastReactionMessageId`
      // on each chat (set by getUserChats for chats with an UNSEEN reaction on
      // one of my messages). Only unread, unopened rows may seed the marker —
      // opening a chat zeros unseenChatCount / sets isOpened but used to leave
      // `lastReactionMessageId` on the cached row, so the next list dispatch
      // re-seeded the id and the bubble highlighted on every enter whenever
      // the last activity was a quick-reaction.
      const incoming = action.messages || [];
      let messagesChanged = false;
      const messages = incoming.map((m) => {
        if (!m || m.lastReactionMessageId == null) return m;
        const unread = Number(m.unseenChatCount) || 0;
        if (unread > 0 && !m.isOpened) return m;
        messagesChanged = true;
        return { ...m, lastReactionMessageId: null };
      });
      let nextReactionIds = state.newReactionMessageIds || [];
      let idsChanged = false;
      for (const m of messages) {
        const rid = m && m.lastReactionMessageId;
        if (rid != null && !nextReactionIds.includes(rid)) {
          if (!idsChanged) {
            nextReactionIds = [...nextReactionIds];
            idsChanged = true;
          }
          nextReactionIds.push(rid);
        }
      }
      const activityMessages = messagesChanged ? messages : action.messages;
      if (idsChanged) {
        return { ...state, activityMessages, newReactionMessageIds: nextReactionIds };
      }
      return { ...state, activityMessages };
    }
    case BUMP_CHAT_REACTION: {
      // A quick-reaction landed on one of the current user's messages.
      // Bump that chat's unread badge by 1 AND move it to the top of the
      // list so it behaves like a new message. We don't touch `createdAt`
      // (that drives the row's displayed timestamp and the preview is
      // unchanged), so we tag a `_reactionBumpAt` the email-merged view can
      // sort on. Source of truth is reconciled on the next /badge/count +
      // getUserChats fetch.
      const groupId = action.groupId;
      const chatId = action.chatId;
      const emoji = action.emoji || null;
      const reactorName = action.reactorName || null;
      const list = state.activityMessages || [];
      const chatIsOpen = !!(groupId && list.some((chat) => chat?.group?.id === groupId && chat?.isOpened));
      // Remember the reacted message id so the bubble can be highlighted the
      // next time the user opens that chat — but only if they weren't already
      // looking at it (they already saw the reaction land live).
      let newReactionMessageIds = state.newReactionMessageIds || [];
      if (chatId != null && !chatIsOpen && !newReactionMessageIds.includes(chatId)) {
        newReactionMessageIds = [...newReactionMessageIds, chatId];
      }
      if (!groupId) {
        return newReactionMessageIds === state.newReactionMessageIds
          ? state
          : { ...state, newReactionMessageIds };
      }
      let bumped = null;
      const rest = [];
      for (const chat of list) {
        if (!bumped && chat?.group?.id === groupId && !chat?.isOpened) {
          bumped = {
            ...chat,
            unseenChatCount: (chat.unseenChatCount || 0) + 1,
            _reactionBumpAt: Date.now(),
            lastReactionEmoji: emoji,
            lastReactionSenderName: reactorName,
          };
        } else {
          rest.push(chat);
        }
      }
      const activityMessages = bumped ? [bumped, ...rest] : state.activityMessages;
      return { ...state, activityMessages, newReactionMessageIds };
    }
    case CLEAR_REACTION_MESSAGES: {
      const ids = action.ids || [];
      if (ids.length === 0) return state;
      const current = state.newReactionMessageIds || [];
      const remaining = current.filter((id) => !ids.includes(id));
      const list = state.activityMessages || [];
      let listChanged = false;
      const nextList = list.map((c) => {
        if (c && ids.includes(c.lastReactionMessageId)) {
          listChanged = true;
          return { ...c, lastReactionMessageId: null };
        }
        return c;
      });
      if (remaining.length === current.length && !listChanged) return state;
      return {
        ...state,
        ...(remaining.length !== current.length ? { newReactionMessageIds: remaining } : {}),
        ...(listChanged ? { activityMessages: nextList } : {}),
      };
    }
    case IS_NEW_MESSAGE:
      return { ...state, isNewMessage: action.status };
    case FOR_OPEN_CHAT_ID:
      return { ...state, forOpenChatId: action.id };
    case RESET_SOCKET:
      return { ...state, resetSocket: action.payload };
    case SET_COMPANY_IMAGE: {
      const p = action.payload;
      if (p && typeof p === "object" && !Array.isArray(p) && ("logo" in p || "name" in p)) {
        return {
          ...state,
          companyImage: p.logo != null ? p.logo : null,
          selectedCompanyName: p.name != null ? p.name : null,
        };
      }
      return {
        ...state,
        companyImage: p,
        selectedCompanyName: p == null ? null : state.selectedCompanyName,
      };
    }
    case SET_COMPANY_ID:
      return { ...state, selectedCompanyId: action.payload };
    case UPDATE_PROJECT_DETAILS:
      return { ...state, shouldUpdateProjectDetails: action.payload };
    case SET_TAB:
      return { ...state, isExternalSelected: action.status };
    case TOGGLE_DRAWER:
      return { ...state, drawerOpen: action.open };
    case TOGGLE_SIDE_NAV:
      return { ...state, sideNavOpen: action.sideNavOpen };
    case START_JITSI_CALL:
      return { ...state, isJitsiCallStarted: action.payload };
    case SET_USER:
      return { ...state, user: action.user };
    case SET_PROFILE:
      return { ...state, profile: action.profile };
    case SET_SETTING:
      return { ...state, setting: action.setting };
    case SET_ACTIVE_STATE:
      return { ...state, activeState: action.activeState };
    case SET_TITLE:
      return { ...state, title: action.title };
    case SET_LOADER:
      return { ...state, loader: action.loader };
    case PROJECTS:
      return { ...state, projects: applyBriefingCountsToProjects(action.projects, state.unseenDailyBriefingByBuilding) };
    case SET_ALLGROUPS_PROJECTS: {
      let projectGroups = [...state.AllGroupsOfProjects]
      let { projectId, newGroups } = action.payload
      let userIndex = projectGroups.findIndex(e => e.projectId == projectId)
      if (userIndex == -1) {
        let obj = {
          projectId: projectId,
          groups: [...newGroups],
        }
        projectGroups.push(obj)
      }
      else {
        projectGroups[userIndex]['groups'] = [...newGroups]
      }
      return {
        ...state,
        AllGroupsOfProjects: [...projectGroups],
      }
    };
    case INTERNAL_PROJECTS:
      return { ...state, internalProjectsAll: applyBriefingCountsToInternal(action.projects, state.unseenDailyBriefingByBuilding) };
    case JOIN_ROOM_BUTTON_STATUS_ROOM_WISE:
      return { ...state, joinNowRoomWise: action.payload };
    case OPEN_PROJECTS:
      return { ...state, openProjects: action.openProjects };
    case SET_PINNED_ROOMS:
      return { ...state, pinnedRooms: Array.isArray(action.payload) ? action.payload : [] };
    case SET_ACTIVE_PINNED_ROOM_ID:
      return { ...state, activePinnedRoomId: action.payload != null ? action.payload : null };
    case SET_OVERSIGHT_ROOM:
      return { ...state, oversightRoom: action.payload || null };
    case UPDATE_PROJECT_ACTION_FIRE:
      return {
        ...state,
        updateProjectActionFire: action.updateProjectActionFire,
      };
    case OPEN_BOTTOM_PROJECTS:
      return { ...state, openBottomProjects: action.openBottomProjects };
    case UPDATE_BOTTOM_PROJECT_ACTION_FIRE:
      return {
        ...state,
        updateBottomProjectActionFire: action.updateBottomProjectActionFire,
      };
    case SET_OPEN_SIDE_BAR:
      return { ...state, activeSideBar: action.payload };  
    case ARTICLE:
      console.log('Redux ARTICLE action:', {
        articleId: action.article?.id,
        articlesListLength: action.articlesList?.length,
        currentArticleIndex: action.currentArticleIndex,
        articleIds: action.articlesList?.map(a => a?.id)
      });
      return { 
        ...state, 
        article: action.article,
        articlesList: action.articlesList !== undefined ? action.articlesList : (state.articlesList || []),
        currentArticleIndex: action.currentArticleIndex !== undefined ? action.currentArticleIndex : (state.currentArticleIndex || 0)
      };
    case TOGGLE_WORK_AREA:
      return { ...state, toggleWorkArea: action.toggleWorkArea };
    case RIGHT_TOP:
      return { ...state, rightTop: action.rightTop };
    case RIGHT_BOTTOM:
      return { ...state, rightBottom: action.rightBottom };
    case GROUPS:
      return { ...state, groups: action.groups };
    case SET_JOIN_REQUEST_EXTERNAL: {
      // Deduplicate by requestId before storing
      const requestMap = new Map();
      (action.requests || []).forEach(req => {
        if (req?.requestId && !requestMap.has(req.requestId)) {
          requestMap.set(req.requestId, req);
        }
      });
      return { ...state, joinRequestsExternal: Array.from(requestMap.values()) };
    }
    case SET_JOIN_REQUEST_INTERNAL: {
      // Deduplicate by requestId before storing
      const requestMap = new Map();
      (action.requests || []).forEach(req => {
        if (req?.requestId && !requestMap.has(req.requestId)) {
          requestMap.set(req.requestId, req);
        }
      });
      return { ...state, joinRequestsInternal: Array.from(requestMap.values()) };
    }
    case GROUPS_BOTTOM:
      return { ...state, groupsBottom: action.groupsBottom };
    case OPEN_CHATS:
      return { ...state, openChats: action.openChats };
    case OPEN_BOTTOM_CHATS:
      return { ...state, openBottomChats: action.openBottomChats };
    case NEWS_BADGE_COUNT:
      return { ...state, unseenNewsCount: action.counters };
    case PROJECT_BADGE_COUNT:
      return { ...state, unseenBuildingChatCount: action.counters };
    case CHAT_BADGE_COUNT:
      return { ...state, unseenChatCount: action.counters };
    case UNSEEN_EXTERNAL_BADGE:
      return { ...state, unseenExternalProject: action.counters };
    case UNSEEN_INTERNAL_BADGE:
      return { ...state, unseenInternalProject: action.counters };
    case ALL_BADGE_COUNT: {
      const rawIncoming = action.unSeenAllCount || {};
      const currentBadges = state.unSeenAllCount || {};
      for (const key of BADGE_GUARD_KEYS) {
        if ((Number(rawIncoming[key]) || 0) < (Number(currentBadges[key]) || 0)) {
          suppressBadgeIncreases();
          break;
        }
      }
      const incoming = clampStaleBadgeIncreases(rawIncoming, currentBadges);
      const emailCount = incoming.unseenEmailCount || 0;
      const todoCount = incoming.unseenTodoCount || 0;
      const briefingCount = Number(incoming.unseenDailyBriefingCount) || 0;
      const emojiReactionCount = incoming.unseenEmojiReactionCount || 0;
      let cnt = incoming.unseenBuildingChatCount + incoming.unseenChatCount + emailCount;
      if (window.electron && typeof window.electron.sendBadgeUpdate === 'function')
        window.electron.sendBadgeUpdate(cnt);
      // Article watermarks are merged rather than replaced: the BE only reports
      // companies that currently have unseen articles, so a blind overwrite
      // would drop the watermark of every company the user is caught up on.
      const incomingSeenAt = incoming.articleSeenAt;
      const articleSeenAt = incomingSeenAt
        ? {
          external: Number(incomingSeenAt.external) || state.articleSeenAt.external || 0,
          byCompany: {
            ...state.articleSeenAt.byCompany,
            ...(incomingSeenAt.byCompany || []).reduce((acc, entry) => {
              if (entry && entry.company) acc[entry.company] = Number(entry.lastSeenAt) || 0;
              return acc;
            }, {}),
          },
        }
        : state.articleSeenAt;
      const briefingByBuilding = incoming.unseenDailyBriefingByBuilding;
      const hasBriefingMap = briefingByBuilding != null && typeof briefingByBuilding === "object";
      const nextBriefingByBuilding = hasBriefingMap
        ? briefingByBuilding
        : state.unseenDailyBriefingByBuilding;
      return {
        ...state,
        unSeenAllCount: incoming,
        articleSeenAt,
        unseenEmailCount: emailCount,
        unseenTodoCount: todoCount,
        unseenDailyBriefingCount: briefingCount,
        unseenDailyBriefingByBuilding: nextBriefingByBuilding,
        unseenEmojiReactionCount: emojiReactionCount,
        projects: hasBriefingMap
          ? applyBriefingCountsToProjects(state.projects, nextBriefingByBuilding)
          : state.projects,
        internalProjectsAll: hasBriefingMap
          ? applyBriefingCountsToInternal(state.internalProjectsAll, nextBriefingByBuilding)
          : state.internalProjectsAll,
      };
    }
    // Realtime +1 from the `articleBadge` socket event.
    case ARTICLE_BADGE_BUMP: {
      const { feedType, company } = action;
      const prev = state.unSeenAllCount || {};
      if (Number(feedType) !== 1) {
        return {
          ...state,
          unSeenAllCount: {
            ...prev,
            unseenArticleExternal: (prev.unseenArticleExternal || 0) + 1,
          },
        };
      }
      if (!company) return state;
      const byCompany = Array.isArray(prev.unseenArticleByCompany)
        ? [...prev.unseenArticleByCompany]
        : [];
      const idx = byCompany.findIndex((e) => e && e.company === company);
      if (idx >= 0) byCompany[idx] = { ...byCompany[idx], count: (byCompany[idx].count || 0) + 1 };
      else byCompany.push({ company, count: 1 });
      return {
        ...state,
        unSeenAllCount: {
          ...prev,
          unseenArticleInternal: (prev.unseenArticleInternal || 0) + 1,
          unseenArticleByCompany: byCompany,
        },
      };
    }
    // Optimistic clear when a feed is opened. Advancing the watermark here means
    // the next visit no longer flags what the user just looked at.
    case ARTICLE_FEED_SEEN: {
      const { feedType, company } = action;
      const seenAt = Number(action.seenAt) || Math.floor(Date.now() / 1000);
      const prev = state.unSeenAllCount || {};
      if (Number(feedType) !== 1) {
        return {
          ...state,
          unSeenAllCount: { ...prev, unseenArticleExternal: 0 },
          articleSeenAt: { ...state.articleSeenAt, external: seenAt },
        };
      }
      const prevByCompany = Array.isArray(prev.unseenArticleByCompany)
        ? prev.unseenArticleByCompany
        : [];
      // No company means "clear every internal company" — what a user with a
      // single Kjuup+ company gets when opening the Internal tab.
      if (!company) {
        const cleared = { ...state.articleSeenAt.byCompany };
        prevByCompany.forEach((e) => { if (e && e.company) cleared[e.company] = seenAt; });
        return {
          ...state,
          unSeenAllCount: { ...prev, unseenArticleInternal: 0, unseenArticleByCompany: [] },
          articleSeenAt: { ...state.articleSeenAt, byCompany: cleared },
        };
      }
      const removed = prevByCompany.find((e) => e && e.company === company);
      return {
        ...state,
        unSeenAllCount: {
          ...prev,
          unseenArticleInternal: Math.max(0, (prev.unseenArticleInternal || 0) - (removed?.count || 0)),
          unseenArticleByCompany: prevByCompany.filter((e) => e && e.company !== company),
        },
        articleSeenAt: {
          ...state.articleSeenAt,
          byCompany: { ...state.articleSeenAt.byCompany, [company]: seenAt },
        },
      };
    }
    case PROJECT_REQUEST_COUNT:
      return { ...state, projectRequestCount: action.projectRequestCount };
    case SHOW_LIST_ONGOING:
      return { ...state, showListOngoing: action.payload };
    case FORWARD_MESSAGE:
      return { ...state, forwardMessage: action.forwardMessage };
    case FORWARD_GROUP_MESSAGES:
      return { ...state, forwardGroupMessages: action.forwardGroupMessages };
    case MESSAGE_IDS:
      return { ...state, messageIds: action.messageIds };
    case UPDATE_GROUP_MESSAGE:
      return { ...state, updateGroupMessage: action.updateGroupMessage };
    case LANGUAGE:
      return { ...state, language: action.language };
    case SET_IN_ACTIVITY:
      return { ...state, inActivity: action.status };
    case GROUP_CHATS:
      return { ...state, groupChats: action.groupChats };
    case DRAFT_MESSAGES:
      return { ...state, draftMessages: action.draftMessages };
    case SET_VIEWER_IMAGES:
      return { ...state, ViewerImages: action.ViewerImages };
    case SET_VIEWER_IINITAL_INDEX:
      return { ...state, initalIndex: action.index };
    case SET_VIEWER_IS_INTERNAL:
      return { ...state, viewerIsInternal: action.isInternal };
    case RESET:
      return initialState;
    case SET_SCREEN_TYPE:
      return {
        ...state,
        isDeskTopResolution: action.payload,
      };
    case SET_DEEPLINK_DATA:
      return { ...state, deeplinkData: action.payload };
    case SET_PENDING_EMAIL_OPEN:
      return { ...state, pendingEmailOpen: action.payload };
    case TOGGLE_CHAT:
      return { ...state, openChatToggle: action.payload !== undefined ? action.payload : !state.openChatToggle };
    case TOGGLE_PROJECT:
      return { ...state, openProjectToggle: action.payload !== undefined ? action.payload : !state.openProjectToggle };
    case TOGGLE_PROJECT_DETAIL:
      return { ...state, openProjectDetailToggle: !state.openProjectDetailToggle };
    case TOGGLE_GROUP_CHAT:
      return { ...state, openGroupChatToggle: !state.openGroupChatToggle };
    case TOGGLE_LATEST_MSG:
      return { ...state, openLatestMsgToggle: action.payload !== undefined ? action.payload : !state.openLatestMsgToggle };
    // Message caching reducers
    case SET_CACHED_MESSAGES: {
      const { chatId, rawMessages } = action.payload;
      // Special case: clear a specific chat's cache
      if (chatId === '__CLEAR__' || (chatId && rawMessages === null)) {
        const updatedCache = { ...state.cachedMessages };
        if (chatId !== '__CLEAR__') {
          delete updatedCache[chatId];
        }
        return {
          ...state,
          cachedMessages: updatedCache
        };
      }
      return {
        ...state,
        cachedMessages: {
          ...state.cachedMessages,
          [chatId]: {
            rawMessages: rawMessages || [],
            lastFetched: Date.now()
          }
        }
      };
    }
    case UPDATE_CACHED_MESSAGE: {
      const { chatId, message } = action.payload;
      const existingCache = state.cachedMessages[chatId];
      if (!existingCache || !existingCache.rawMessages) return state;
      // Add new message to the beginning of raw messages array
      const updatedRawMessages = [message, ...existingCache.rawMessages].slice(0, 100);
      return {
        ...state,
        cachedMessages: {
          ...state.cachedMessages,
          [chatId]: {
            rawMessages: updatedRawMessages,
            lastFetched: Date.now()
          }
        }
      };
    }
    case CLEAR_CACHED_MESSAGES:
      return { ...state, cachedMessages: {}, activityMessagesLastFetched: null };
    case SET_ACTIVITY_MESSAGES_LAST_FETCHED:
      return { ...state, activityMessagesLastFetched: action.payload };
    case SET_CHAT_FULLSCREEN:
      return { ...state, chatFullscreen: action.payload };
    case EMAIL_SYNC: {
      // Only stash the sync payload here so the list-merge effect in
      // LatestMessages can propagate new rows / read-state changes. The
      // badge counter is deliberately NOT touched: the socket "email"
      // handler always force-fetches /badge/count immediately after this
      // dispatch and reconciles via ALL_BADGE_COUNT, which is the single
      // source of truth for unseenEmailCount. Optimistically bumping the
      // count here caused a visible flicker — the counter jumped to N and
      // then snapped back to the authoritative value on every sync poll.
      const emailSyncSeq = state.emailSyncSeq + 1;
      return {
        ...state,
        emailSyncData: action.payload,
        emailSyncSeq,
        emailSyncEvents: appendEmailSyncEvent(state.emailSyncEvents, action.payload, emailSyncSeq),
      };
    }
    case EMAIL_CATCH_UP:
      return { ...state, emailCatchUpAt: action.payload || Date.now() };
    case EMAIL_ACCOUNTS_CHANGED:
      // Nonce (timestamp) that screens holding a local email-account list watch
      // to trigger a re-fetch when another device links/unlinks an account.
      return { ...state, emailAccountsChangedAt: action.payload || Date.now() };
    case MY_SPACE_PINNED: {
      const groupId = action.groupId;
      const isPinned = !!action.isPinned;
      if (!groupId) {
        return { ...state, mySpacePin: { groupId: null, isPinned, at: Date.now() } };
      }
      const patchPin = (list) => (list || []).map((chat) => {
        if (!chat?.group || String(chat.group.id) !== String(groupId)) return chat;
        return { ...chat, group: { ...chat.group, isPinned, isSelfChat: true } };
      });
      return {
        ...state,
        mySpacePin: { groupId, isPinned, at: Date.now() },
        activityMessages: patchPin(state.activityMessages),
        activityMessagesReminders: patchPin(state.activityMessagesReminders),
      };
    }
    case RESET_UNSEEN_EMAIL_COUNT:
      return { ...state, unseenEmailCount: 0, unSeenAllCount: { ...state.unSeenAllCount, unseenEmailCount: 0 } };
    case DECREMENT_UNSEEN_EMAIL_COUNT: {
      // `count` lets callers decrement by N in one dispatch (e.g. batch
      // "mark read" of selected emails). Defaults to 1 for back-compat.
      suppressBadgeIncreases();
      const delta = typeof action.count === "number" && action.count > 0 ? action.count : 1;
      const dec = Math.max(0, state.unseenEmailCount - delta);
      return { ...state, unseenEmailCount: dec, unSeenAllCount: { ...state.unSeenAllCount, unseenEmailCount: dec } };
    }
    case INCREMENT_UNSEEN_EMAIL_COUNT: {
      // Mirror of DECREMENT_UNSEEN_EMAIL_COUNT for batch "mark unread".
      allowBadgeIncreases();
      const delta = typeof action.count === "number" && action.count > 0 ? action.count : 1;
      const inc = state.unseenEmailCount + delta;
      return { ...state, unseenEmailCount: inc, unSeenAllCount: { ...state.unSeenAllCount, unseenEmailCount: inc } };
    }
    case DECREMENT_UNSEEN_TODO_COUNT: {
      const todoDec = Math.max(0, state.unseenTodoCount - 1);
      return { ...state, unseenTodoCount: todoDec, unSeenAllCount: { ...state.unSeenAllCount, unseenTodoCount: todoDec } };
    }
    case INCREMENT_UNSEEN_TODO_COUNT: {
      const todoInc = state.unseenTodoCount + 1;
      return { ...state, unseenTodoCount: todoInc, unSeenAllCount: { ...state.unSeenAllCount, unseenTodoCount: todoInc }, todoListRefreshTrigger: state.todoListRefreshTrigger + 1 };
    }
    case REFRESH_TODO_LIST:
      return { ...state, todoListRefreshTrigger: state.todoListRefreshTrigger + 1 };
    case TODO_CALENDAR_REMOVED:
      return {
        ...state,
        todoCalendarRemovedSeq: state.todoCalendarRemovedSeq + 1,
        todoCalendarRemovedTodoId: action.todoId || null,
        todoListRefreshTrigger: state.todoListRefreshTrigger + 1,
      };
    case TODO_CALENDAR_DELETED:
      return {
        ...state,
        todoCalendarDeletedTodoId: action.todoId || null,
        todoListRefreshTrigger: state.todoListRefreshTrigger + 1,
      };
    case TODO_ITEM_REMOVED:
      return {
        ...state,
        todoRemovedSeq: (state.todoRemovedSeq || 0) + 1,
        todoRemovedTodoId: action.todoId || null,
        todoRemovedGroupId: action.groupId || null,
        todoRemovedEmailId: action.emailId || null,
        bookmarkedChatIds: action.chatId
          ? (state.bookmarkedChatIds || []).filter((id) => String(id) !== String(action.chatId))
          : state.bookmarkedChatIds || [],
        pendingBookmarks: dropPendingBookmark(state.pendingBookmarks, {
          todoId: action.todoId,
          id: action.todoId,
          chatId: action.chatId,
          groupId: action.groupId,
          emailId: action.emailId,
        }),
      };
    case BOOKMARK_TODO_PENDING: {
      const chatId = action.chatId ? String(action.chatId) : null;
      const ids = new Set((state.bookmarkedChatIds || []).map(String));
      if (chatId) ids.add(chatId);
      const pendingItem = {
        id: action.tempId,
        todoId: action.tempId,
        tempId: action.tempId,
        description: action.description || "",
        isBookmarked: true,
        isCreating: true,
        createdAt: new Date().toISOString(),
        chatId: action.chatId || null,
        messageId: action.chatId || null,
        groupId: action.groupId || null,
        emailMessageId: action.emailId || null,
        roomId: action.roomId || null,
        buildingList: action.roomId || null,
        status: "pending",
      };
      return {
        ...state,
        bookmarkedChatIds: Array.from(ids),
        pendingBookmarks: upsertPendingBookmark(state.pendingBookmarks, pendingItem),
        bookmarkTodoEventSeq: (state.bookmarkTodoEventSeq || 0) + 1,
        bookmarkTodoEvent: {
          type: "pending",
          tempId: action.tempId,
          chatId: action.chatId || null,
          groupId: action.groupId || null,
          emailId: action.emailId || null,
          roomId: action.roomId || null,
          description: action.description || "",
        },
      };
    }
    case BOOKMARK_TODO_CREATED: {
      const chatId = action.chatId ? String(action.chatId) : null;
      const ids = new Set((state.bookmarkedChatIds || []).map(String));
      if (chatId) ids.add(chatId);
      const src = action.todo || {};
      const createdItem = {
        ...src,
        id: src.id || src.todoId || action.tempId,
        todoId: src.id || src.todoId || action.tempId,
        tempId: action.tempId || null,
        description: src.description || action.description || "",
        isCreating: false,
        isBookmarked: true,
        chatId: src.chat || action.chatId || null,
        messageId: src.chat || src.messageId || action.chatId || null,
        groupId: src.group || src.groupId || action.groupId || null,
        roomId: src.buildingList || src.roomId || action.roomId || null,
        buildingList: src.buildingList || action.roomId || null,
        createdAt: src.createdAt || new Date().toISOString(),
        assignedTo: src.assignedTo || [],
        assignedUsers: src.assignedUsers || [],
      };
      return {
        ...state,
        bookmarkedChatIds: Array.from(ids),
        pendingBookmarks: upsertPendingBookmark(state.pendingBookmarks, createdItem),
        bookmarkTodoEventSeq: (state.bookmarkTodoEventSeq || 0) + 1,
        bookmarkTodoEvent: {
          type: "created",
          tempId: action.tempId || null,
          chatId: action.chatId || null,
          groupId: action.groupId || null,
          roomId: action.roomId || null,
          todo: action.todo || null,
        },
      };
    }
    case BOOKMARK_TODO_FAILED: {
      const chatId = action.chatId ? String(action.chatId) : null;
      return {
        ...state,
        bookmarkedChatIds: chatId
          ? (state.bookmarkedChatIds || []).filter((id) => String(id) !== chatId)
          : state.bookmarkedChatIds || [],
        pendingBookmarks: dropPendingBookmark(state.pendingBookmarks, {
          tempId: action.tempId,
          id: action.tempId,
          todoId: action.tempId,
          chatId: action.chatId,
        }),
        bookmarkTodoEventSeq: (state.bookmarkTodoEventSeq || 0) + 1,
        bookmarkTodoEvent: {
          type: "failed",
          tempId: action.tempId || null,
          chatId: action.chatId || null,
        },
      };
    }
    case MERGE_BOOKMARKED_CHAT_IDS: {
      const extra = Array.isArray(action.chatIds) ? action.chatIds : [];
      const ids = new Set((state.bookmarkedChatIds || []).map(String));
      extra.forEach((id) => {
        if (id) ids.add(String(id));
      });
      return { ...state, bookmarkedChatIds: Array.from(ids) };
    }
    case RESET_UNSEEN_TODO_COUNT:
      return { ...state, unseenTodoCount: 0, unSeenAllCount: { ...state.unSeenAllCount, unseenTodoCount: 0 } };
    case INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT: {
      const briefingInc = state.unseenDailyBriefingCount + 1;
      const buildingId = action.buildingId;
      const nextByBuilding = bumpBriefingByBuilding(state.unseenDailyBriefingByBuilding, buildingId, 1);
      return {
        ...state,
        unseenDailyBriefingCount: briefingInc,
        unseenDailyBriefingByBuilding: nextByBuilding,
        unSeenAllCount: {
          ...adjustBriefingTabCounts(state.unSeenAllCount, action.isInternal, 1),
          unseenDailyBriefingCount: briefingInc,
        },
        projects: adjustProjectBriefingCount(state.projects, buildingId, 1),
        internalProjectsAll: adjustInternalBriefingCount(state.internalProjectsAll, buildingId, 1),
      };
    }
    case DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT: {
      suppressBadgeIncreases();
      const prevTotal = Math.max(
        Number(state.unseenDailyBriefingCount) || 0,
        Number(state.unSeenAllCount?.unseenDailyBriefingCount) || 0,
        (Number(state.unSeenAllCount?.unseenExternalDailyBriefingCount) || 0) +
          (Number(state.unSeenAllCount?.unseenInternalDailyBriefingCount) || 0)
      );
      const briefingDec = Math.max(0, prevTotal - 1);
      const buildingId = action.buildingId;
      const nextByBuilding = bumpBriefingByBuilding(state.unseenDailyBriefingByBuilding, buildingId, -1);
      return {
        ...state,
        unseenDailyBriefingCount: briefingDec,
        unseenDailyBriefingByBuilding: nextByBuilding,
        unSeenAllCount: {
          ...adjustBriefingTabCounts(state.unSeenAllCount, action.isInternal, -1),
          unseenDailyBriefingCount: briefingDec,
        },
        projects: adjustProjectBriefingCount(state.projects, buildingId, -1),
        internalProjectsAll: adjustInternalBriefingCount(state.internalProjectsAll, buildingId, -1),
      };
    }
    case INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT: {
      const prev = state.unSeenAllCount || {};
      const next = (Number(prev.unseenAllScopeDailyBriefingCount) || 0) + 1;
      return {
        ...state,
        unSeenAllCount: { ...prev, unseenAllScopeDailyBriefingCount: next },
      };
    }
    case DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT: {
      suppressBadgeIncreases();
      const prev = state.unSeenAllCount || {};
      const next = Math.max(0, (Number(prev.unseenAllScopeDailyBriefingCount) || 0) - 1);
      return {
        ...state,
        unSeenAllCount: { ...prev, unseenAllScopeDailyBriefingCount: next },
      };
    }
    case SET_EMAIL_SEARCH:
      return {
        ...state,
        emailSearchQuery: action.payload.query !== undefined ? action.payload.query : state.emailSearchQuery,
        emailSearchResults: action.payload.results !== undefined ? action.payload.results : state.emailSearchResults,
        emailSearchPagination: action.payload.pagination !== undefined ? action.payload.pagination : state.emailSearchPagination,
        isEmailSearching: action.payload.isSearching !== undefined ? action.payload.isSearching : state.isEmailSearching,
        emailSearchError: action.payload.error !== undefined ? action.payload.error : state.emailSearchError,
      };
    case CLEAR_EMAIL_SEARCH:
      return {
        ...state,
        emailSearchQuery: '',
        emailSearchResults: [],
        emailSearchPagination: { page: 1, hasMore: false },
        isEmailSearching: false,
        emailSearchError: null,
      };
    case SET_EMAIL_ACCOUNTS: {
      const accounts = Array.isArray(action.payload) ? action.payload : [];
      const next = { ...state, emailAccounts: accounts };
      // Disconnecting the last mailbox must drop the unread-email badge
      // immediately — /badge/count is not refetched from every screen.
      if (accounts.length === 0) {
        next.unseenEmailCount = 0;
        next.unSeenAllCount = { ...state.unSeenAllCount, unseenEmailCount: 0 };
      }
      return next;
    }
    case SET_EMAIL_CUSTOM_FOLDERS:
      return { ...state, emailCustomFolders: action.payload };
    case SET_SUBSCRIPTION_LOADING:
      return {
        ...state,
        subscription: { ...state.subscription, loading: !!action.payload },
      };
    case SET_SUBSCRIPTION_STATUS: {
      const p = action.payload || {};
      return {
        ...state,
        subscription: {
          ...state.subscription,
          active: !!p.active,
          plan: p.plan ?? null,
          subscriptionStatus: p.subscriptionStatus ?? null,
          currentPeriodEnd: p.currentPeriodEnd ?? null,
          cancelAtPeriodEnd: !!p.cancelAtPeriodEnd,
          subscriptionId: p.subscriptionId ?? null,
          pendingPlan: p.pendingPlan ?? null,
          pendingStartDate: p.pendingStartDate ?? null,
          hasScheduledSwitch: !!p.hasScheduledSwitch,
          trialing: !!(
            p.trialing ||
            p.isTrialing ||
            p.subscriptionStatus === "trialing" ||
            (!!p.active &&
              p.subscriptionStatus !== "canceled" &&
              p.subscriptionStatus !== "cancelled" &&
              (p.daysRemaining != null || p.trialDaysRemaining != null))
          ),
          trialEnd: p.trialEnd ?? null,
          daysRemaining:
            p.daysRemaining != null
              ? Number(p.daysRemaining)
              : p.trialDaysRemaining != null
                ? Number(p.trialDaysRemaining)
                : null,
          trialDaysRemaining:
            p.trialDaysRemaining != null
              ? Number(p.trialDaysRemaining)
              : p.daysRemaining != null
                ? Number(p.daysRemaining)
                : null,
          trialPeriodDays: p.trialPeriodDays ?? null,
          clockOffsetMs: Number.isFinite(p.clockOffsetMs) ? p.clockOffsetMs : 0,
          discount: p.discount ?? null,
          hasPaymentMethod: !!p.hasPaymentMethod,
          hasUsedTrial: !!p.hasUsedTrial,
          canStartTrial:
            p.canStartTrial != null ? !!p.canStartTrial : !p.hasUsedTrial && !p.active,
          isKjuupPlusMember: !!p.isKjuupPlusMember,
          stripeFeatureEnabled:
            p.stripeFeatureEnabled != null ? !!p.stripeFeatureEnabled : false,
          companyStripeFeatureEnabled: !!p.companyStripeFeatureEnabled,
          source: p.source ?? null,
          companyBilling: p.companyBilling ?? null,
          companyTrialEnded: !!p.companyTrialEnded,
          showCompanyTrialEndedNote: !!p.showCompanyTrialEndedNote,
          isCompanyAdmin: !!p.isCompanyAdmin,
          hasCompanySeat: !!p.hasCompanySeat,
          companyAdmins: Array.isArray(p.companyAdmins) ? p.companyAdmins : [],
          loading: false,
          lastFetchedAt: Date.now(),
        },
      };
    }
    case CLEAR_SUBSCRIPTION:
      return { ...state, subscription: { ...SUBSCRIPTION_INITIAL } };
    default:
      return state;
  }
}, reduxDevTools);


